import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Box, Typography } from '@mui/material';
import NeckLayers from './NeckLayers';
// import PaintModeControls from './PaintModeControls'; // paint mode postponed
import SlidingSubmenu from './SlidingSubmenu';

const NeckControls = ({
  activeScale,
  startFret,
  startPatternFret,
  highlightArpeggios,
  setHighlightArpeggios,
  showConnectionLines,
  setShowConnectionLines,
  showWholeScale,
  setShowWholeScale,
  lessonMode = false,
  selectedNotes = [],
  onClearSelectedNotes,
  isStartNoteSelectionMode = false,
  onStartNoteSelectionMode,
  currentColor = 'orange',
  onColorSelect,
  visibleColors = ['orange', 'red', 'green', 'blue'],
  onToggleColorVisibility,
  selectedArpeggio = null,
  setSelectedArpeggio = () => {},
  isFretboardLocked = false,
  onToggleFretboardLock,
  onShowPatternSnackbar,
  className = "",
  rootNote,
  currentMode,
  activeChordNote,
  playingNote,
  highlightChordNotes,
  setHighlightChordNotes,
  currentProgression,
  isPaintMode = false,
  onPaintModeChange,
  noteDisplayMode = 'none',
  setNoteDisplayMode,
  isCompactMode = false,
  trackedDegree = 1,
  setTrackedDegree,
  chordExtension = '3',
  earSequence = [],
  onEarStep
}) => {
  // Main content that will slide away when paint mode is active
  const mainContent = (
    <Box className={`neck-controls ${className}`} sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      mb: 1,
      width: '100%',
      px: { sm: 0, md: 1.25 },
      pt: { xs: 0, md: 0 },
      boxSizing: 'border-box',
      '@media (orientation: landscape)': {
        mb: 0,
        justifyContent: 'center'
      }
    }}>
      {/* Toolbar Controls */}
      <Box className="controls" sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        '@media (orientation: landscape)': {
          justifyContent: 'flex-end'
        }
      }}>
          <NeckLayers
            highlightArpeggios={highlightArpeggios}
            setHighlightArpeggios={setHighlightArpeggios}
            showConnectionLines={showConnectionLines}
            setShowConnectionLines={setShowConnectionLines}
            showWholeScale={showWholeScale}
            setShowWholeScale={setShowWholeScale}
            lessonMode={lessonMode}
            selectedNotes={selectedNotes}
            onClearSelectedNotes={onClearSelectedNotes}
            isStartNoteSelectionMode={isStartNoteSelectionMode}
            onStartNoteSelectionMode={onStartNoteSelectionMode}
            currentColor={currentColor}
            onColorSelect={onColorSelect}
            visibleColors={visibleColors}
            onToggleColorVisibility={onToggleColorVisibility}
            activeScale={activeScale}
            selectedArpeggio={selectedArpeggio}
            setSelectedArpeggio={setSelectedArpeggio}
            isFretboardLocked={isFretboardLocked}
            onToggleFretboardLock={onToggleFretboardLock}
            onShowPatternSnackbar={onShowPatternSnackbar}
            isPaintMode={isPaintMode}
            onPaintModeChange={onPaintModeChange}
            activeChordNote={activeChordNote}
            playingNote={playingNote}
            highlightChordNotes={highlightChordNotes}
            setHighlightChordNotes={setHighlightChordNotes}
            noteDisplayMode={noteDisplayMode}
            setNoteDisplayMode={setNoteDisplayMode}
            className="neck-layers"
            isCompactMode={isCompactMode}
            rootNote={rootNote}
            currentMode={currentMode}
            trackedDegree={trackedDegree}
            setTrackedDegree={setTrackedDegree}
            chordExtension={chordExtension}
            earSequence={earSequence}
            onEarStep={onEarStep}
          />
        </Box>
    </Box>
  );

  // Paint mode postponed to a later release: keep the component wired but render
  // no paint panel so it stays out of the DOM. Re-enable by restoring
  // paintModeContent below and passing it as the submenu's children.
  // const paintModeContent = (
  //   <PaintModeControls
  //     currentColor={currentColor}
  //     onColorSelect={onColorSelect}
  //     visibleColors={visibleColors}
  //     onToggleColorVisibility={onToggleColorVisibility}
  //   />
  // );

  return (
    <SlidingSubmenu
      isOpen={isPaintMode}
      onClose={() => onPaintModeChange && onPaintModeChange(false)}
      mainContent={mainContent}
      title={null}
      showCloseButton={false}
    />
  );
};

// La barre d'outils vit dans #sliding-submenu-portal (header-row) : en paysage
// elle se place a droite, sur la meme ligne que les pills de gamme
const NeckControlsInHeader = (props) => {
  const [portalTarget, setPortalTarget] = useState(null);

  useEffect(() => {
    setPortalTarget(document.getElementById('sliding-submenu-portal'));
  }, []);

  const content = <NeckControls {...props} />;
  return portalTarget ? createPortal(content, portalTarget) : content;
};

export default NeckControlsInHeader;
